import React, { useEffect, useRef, useState } from 'react';
import '../styles/components/ScrollDownButton.css';

const ScrollDownButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);
  const navHeightRef = useRef(0);

  useEffect(() => {
    const nav = document.querySelector<HTMLElement>('nav, header, .navbar');
    navHeightRef.current = nav?.offsetHeight ?? 0;

    const handleScroll = () => {
      const scrolledToBottom =
        window.innerHeight + window.pageYOffset >=
        document.documentElement.scrollHeight - 50;

      setIsVisible(!scrolledToBottom);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    const sections = Array.from(
      document.querySelectorAll<HTMLElement>('.section')
    );

    const nextSection = sections.find((section) => {
      const rect = section.getBoundingClientRect();
      return rect.top > window.innerHeight * 0.25;
    });

    // Fallback — always scroll
    if (!nextSection) {
      window.scrollBy({
        top: window.innerHeight * 0.8,
        behavior: 'smooth',
      });
      return;
    }

    const sectionTop = nextSection.offsetTop;
    const sectionHeight = nextSection.offsetHeight;
    const navHeight = navHeightRef.current;

    const EXTRA_SCROLL_PX = 24;

    let targetY =
      sectionTop -
      window.innerHeight / 2 +
      sectionHeight / 2 -
      navHeight / 2 +
      EXTRA_SCROLL_PX;

    const maxScroll =
      document.documentElement.scrollHeight - window.innerHeight;

    targetY = Math.min(Math.max(0, targetY), maxScroll);

    window.scrollTo({
      top: Math.round(targetY),
      behavior: 'smooth',
    });
  };

  return (
    <button
      className={`scrollDownButton ${isVisible ? 'visible' : 'hidden'}`}
      onClick={handleClick}
      aria-label="Scroll down"
      type="button"
    >
      ↓
    </button>
  );
};

export default ScrollDownButton;
